<button [disabled]="showLoader || disablePayButton" id="ApplePayButton" class="payment-button apple-payment-button" (click)='handleApplePayClick()'>
  <div class="apple-pay-button-wrapper">
    <div class="apple-pay-button-image-section">
      <!-- <span class="margin-right-8">
        {{appCopy.panelHeader['applePayButtonText'+selectedLanguage]}}
      </span> -->
      <img src="../../../../../images/apple_pay_black.svg" height="25" alt="" />
    </div>
  </div>

</button>
